import * as React from "react";
import { List, Spin } from 'antd';
import * as InfiniteScroll from 'react-infinite-scroller';

import { GetPostListQuery_getPostList } from "@bakbak/controller";
import { PostItemConnector } from "../item/PostItemConnector";

interface Props {
  postList: GetPostListQuery_getPostList[] | null;
  hasMorePosts: boolean;
  loadMore: () => void;
}

class PostListView extends React.PureComponent<Props> {
  renderItem = (post: GetPostListQuery_getPostList) => {
    return <PostItemConnector post={post} />;
  }
  render() {
    const { postList, hasMorePosts, loadMore } = this.props;
    return (
      <div>
        <InfiniteScroll
          initialLoad={false}
          pageStart={0}
          loadMore={loadMore}
          hasMore={hasMorePosts}
          useWindow={true}
        >
          <List
            itemLayout="vertical"
            size="large"
            dataSource={postList}
            renderItem={this.renderItem}
          >
            {hasMorePosts && (
              <div style={loadingContainerStyle}>
                <Spin />
              </div>
            )}
          </List>
        </InfiniteScroll>
      </div>
    );
  }
}

const loadingContainerStyle: any = {
  position: "absolute",
  bottom: "40px",
  width: "100%",
  textAlign: "center"
}

export { PostListView };


// WEBPACK FOOTER //
// ./src/modules/post/list/PostListView.tsx